import { Message, Messages } from '../shared/types'

export default function keyMessagesById(messages: Array<Message>) {
  return messages.reduce((accumulator: Messages, message: Message) => {
    accumulator[message.id] = message
    return accumulator
  }, {} as Messages)
}